// React
import { useCallback } from 'react';
// External Lib
import { useNavigate } from 'react-router-dom';
import { get } from 'lodash';
// Hooks
import hooks from './hooks';
// Styles
import useStyles from './style';
// Component
import BackArrowIcon from '../../../icons/back-arrow-icon/BackArrowIcon';

export function ArticleDetail() {
  const componentClasses = useStyles();
  const article = hooks.useArticle();
  const selectedSubCategoryName = hooks.useSelectedSubCategoryName();
  const selectedArticleName = hooks.useSelectedArticleName();
  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);
  return (
    <div className={componentClasses.root}>
      <div className={componentClasses.title}>
        <div className={componentClasses.arrowIcon} onClick={handleBack}>
          <BackArrowIcon />
        </div>
        {selectedSubCategoryName}
      </div>
      <div className={componentClasses.secondaryTitle}>
        {selectedArticleName}
      </div>
      <div
        className={componentClasses.article}
        dangerouslySetInnerHTML={{
          __html: get(article, 'body', '') || '',
        }}
      ></div>
    </div>
  );
}
